export class MailMessage {
    ReceiverId: number;
    SessionId: string;
    AppId: number;
    Signature: string;
    MessageType: MessageType;
    Attachments: FileHolder[] = [];
    MessageText: string;
    MessageHeader: string;
}

export class FileHolder {
    Data: string;
    Name: string;
}

export enum MessageType {
    Recipe = 1,
    Menu = 2,
    Products = 3,
    Text = 4,
    Application = 5,
    RecipeSingle = 6
}



// WEBPACK FOOTER //
// ./src/app/shared/models/mail-message.model.ts